export default "__VITE_ASSET__Dn55KPBV__"